"use strict";
var $protobuf = require("protobufjs/minimal");
var $Writer = $protobuf.Writer, $util = $protobuf.util;
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});
$root.OsType = (function () {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "UNKNOWN_OS_TYPE"] = 0;
    values[valuesById[1] = "OS_IOS"] = 1;
    values[valuesById[2] = "OS_ANDROID"] = 2;
    values[valuesById[3] = "OS_WEB"] = 3;
    return values;
})();
$root.AppVersion = (function () {
    function AppVersion(p) {
        if (p)
            for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                if (p[ks[i]] != null)
                    this[ks[i]] = p[ks[i]];
    }
    AppVersion.prototype.versionNumber = null;
    AppVersion.prototype.flavor = "";
    AppVersion.prototype.variant = "";
    AppVersion.encode = function encode(m, w) {
        if (!w)
            w = $Writer.create();
        if (m.versionNumber != null && Object.hasOwnProperty.call(m, "versionNumber"))
            $root.AppVersion.VersionNumber.encode(m.versionNumber, w.uint32(10).fork()).ldelim();
        if (m.flavor != null && Object.hasOwnProperty.call(m, "flavor"))
            w.uint32(18).string(m.flavor);
        if (m.variant != null && Object.hasOwnProperty.call(m, "variant"))
            w.uint32(26).string(m.variant);
        return w;
    };
    AppVersion.fromObject = function fromObject(d) {
        if (d instanceof $root.AppVersion)
            return d;
        var m = new $root.AppVersion();
        if (d.versionNumber != null) {
            if (typeof d.versionNumber !== "object")
                throw TypeError(".AppVersion.versionNumber: object expected");
            m.versionNumber = $root.AppVersion.VersionNumber.fromObject(d.versionNumber);
        }
        if (d.flavor != null) {
            m.flavor = String(d.flavor);
        }
        if (d.variant != null) {
            m.variant = String(d.variant);
        }
        return m;
    };
    AppVersion.toObject = function toObject(m, o) {
        if (!o)
            o = {};
        var d = {};
        if (o.defaults) {
            d.versionNumber = null;
            d.flavor = "";
            d.variant = "";
        }
        if (m.versionNumber != null && m.hasOwnProperty("versionNumber")) {
            d.versionNumber = $root.AppVersion.VersionNumber.toObject(m.versionNumber, o);
        }
        if (m.flavor != null && m.hasOwnProperty("flavor")) {
            d.flavor = m.flavor;
        }
        if (m.variant != null && m.hasOwnProperty("variant")) {
            d.variant = m.variant;
        }
        return d;
    };
    AppVersion.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    AppVersion.VersionNumber = (function () {
        function VersionNumber(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }
        VersionNumber.prototype.major = 0;
        VersionNumber.prototype.minor = 0;
        VersionNumber.prototype.patch = 0;
        VersionNumber.prototype.build = 0;
        VersionNumber.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.major != null && Object.hasOwnProperty.call(m, "major"))
                w.uint32(8).int32(m.major);
            if (m.minor != null && Object.hasOwnProperty.call(m, "minor"))
                w.uint32(16).int32(m.minor);
            if (m.patch != null && Object.hasOwnProperty.call(m, "patch"))
                w.uint32(24).int32(m.patch);
            if (m.build != null && Object.hasOwnProperty.call(m, "build"))
                w.uint32(32).int32(m.build);
            return w;
        };
        VersionNumber.fromObject = function fromObject(d) {
            if (d instanceof $root.AppVersion.VersionNumber)
                return d;
            var m = new $root.AppVersion.VersionNumber();
            if (d.major != null) {
                m.major = d.major | 0;
            }
            if (d.minor != null) {
                m.minor = d.minor | 0;
            }
            if (d.patch != null) {
                m.patch = d.patch | 0;
            }
            if (d.build != null) {
                m.build = d.build | 0;
            }
            return m;
        };
        VersionNumber.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.major = 0;
                d.minor = 0;
                d.patch = 0;
                d.build = 0;
            }
            if (m.major != null && m.hasOwnProperty("major")) {
                d.major = m.major;
            }
            if (m.minor != null && m.hasOwnProperty("minor")) {
                d.minor = m.minor;
            }
            if (m.patch != null && m.hasOwnProperty("patch")) {
                d.patch = m.patch;
            }
            if (m.build != null && m.hasOwnProperty("build")) {
                d.build = m.build;
            }
            return d;
        };
        VersionNumber.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };
        return VersionNumber;
    })();
    return AppVersion;
})();
$root.Metric = (function () {
    function Metric(p) {
        this.customDimensions = {};
        this.values = [];
        if (p)
            for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                if (p[ks[i]] != null)
                    this[ks[i]] = p[ks[i]];
    }
    Metric.prototype.partitionName = "";
    Metric.prototype.metricName = "";
    Metric.prototype.customDimensions = $util.emptyObject;
    Metric.prototype.values = $util.emptyArray;
    Metric.encode = function encode(m, w) {
        if (!w)
            w = $Writer.create();
        if (m.partitionName != null && Object.hasOwnProperty.call(m, "partitionName"))
            w.uint32(10).string(m.partitionName);
        if (m.metricName != null && Object.hasOwnProperty.call(m, "metricName"))
            w.uint32(18).string(m.metricName);
        if (m.customDimensions != null && Object.hasOwnProperty.call(m, "customDimensions")) {
            for (var ks = Object.keys(m.customDimensions), i = 0; i < ks.length; ++i) {
                w.uint32(26).fork().uint32(10).string(ks[i]).uint32(18).string(m.customDimensions[ks[i]]).ldelim();
            }
        }
        if (m.values != null && m.values.length) {
            w.uint32(34).fork();
            for (var i = 0; i < m.values.length; ++i)
                w.int64(m.values[i]);
            w.ldelim();
        }
        return w;
    };
    Metric.fromObject = function fromObject(d) {
        if (d instanceof $root.Metric)
            return d;
        var m = new $root.Metric();
        if (d.partitionName != null) {
            m.partitionName = String(d.partitionName);
        }
        if (d.metricName != null) {
            m.metricName = String(d.metricName);
        }
        if (d.customDimensions) {
            if (typeof d.customDimensions !== "object")
                throw TypeError(".Metric.customDimensions: object expected");
            m.customDimensions = {};
            for (var ks = Object.keys(d.customDimensions), i = 0; i < ks.length; ++i) {
                m.customDimensions[ks[i]] = String(d.customDimensions[ks[i]]);
            }
        }
        if (d.values) {
            if (!Array.isArray(d.values))
                throw TypeError(".Metric.values: array expected");
            m.values = [];
            for (var i = 0; i < d.values.length; ++i) {
                if ($util.Long)
                    (m.values[i] = $util.Long.fromValue(d.values[i])).unsigned = false;
                else if (typeof d.values[i] === "string")
                    m.values[i] = parseInt(d.values[i], 10);
                else if (typeof d.values[i] === "number")
                    m.values[i] = d.values[i];
                else if (typeof d.values[i] === "object")
                    m.values[i] = new $util.LongBits(d.values[i].low >>> 0, d.values[i].high >>> 0).toNumber();
            }
        }
        return m;
    };
    Metric.toObject = function toObject(m, o) {
        if (!o)
            o = {};
        var d = {};
        if (o.arrays || o.defaults) {
            d.values = [];
        }
        if (o.objects || o.defaults) {
            d.customDimensions = {};
        }
        if (o.defaults) {
            d.partitionName = "";
            d.metricName = "";
        }
        if (m.partitionName != null && m.hasOwnProperty("partitionName")) {
            d.partitionName = m.partitionName;
        }
        if (m.metricName != null && m.hasOwnProperty("metricName")) {
            d.metricName = m.metricName;
        }
        var ks2;
        if (m.customDimensions && (ks2 = Object.keys(m.customDimensions)).length) {
            d.customDimensions = {};
            for (var j = 0; j < ks2.length; ++j) {
                d.customDimensions[ks2[j]] = m.customDimensions[ks2[j]];
            }
        }
        if (m.values && m.values.length) {
            d.values = [];
            for (var j = 0; j < m.values.length; ++j) {
                if (typeof m.values[j] === "number")
                    d.values[j] = o.longs === String ? String(m.values[j]) : m.values[j];
                else
                    d.values[j] = o.longs === String ? $util.Long.prototype.toString.call(m.values[j]) : o.longs === Number ? new $util.LongBits(m.values[j].low >>> 0, m.values[j].high >>> 0).toNumber() : m.values[j];
            }
        }
        return d;
    };
    Metric.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return Metric;
})();
$root.MetricFrame = (function () {
    function MetricFrame(p) {
        this.timers = [];
        this.counters = [];
        this.levels = [];
        if (p)
            for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                if (p[ks[i]] != null)
                    this[ks[i]] = p[ks[i]];
    }
    MetricFrame.prototype.timers = $util.emptyArray;
    MetricFrame.prototype.counters = $util.emptyArray;
    MetricFrame.prototype.levels = $util.emptyArray;
    MetricFrame.prototype.protocolVersion = 0;
    MetricFrame.prototype.bufferStartTimestampMillis = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    MetricFrame.prototype.bufferEndTimestampMillis = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
    MetricFrame.prototype.appVersion = null;
    MetricFrame.prototype.clientOsType = 0;
    MetricFrame.prototype.userId = "";
    MetricFrame.encode = function encode(m, w) {
        if (!w)
            w = $Writer.create();
        if (m.timers != null && m.timers.length) {
            for (var i = 0; i < m.timers.length; ++i)
                $root.Metric.encode(m.timers[i], w.uint32(10).fork()).ldelim();
        }
        if (m.counters != null && m.counters.length) {
            for (var i = 0; i < m.counters.length; ++i)
                $root.Metric.encode(m.counters[i], w.uint32(18).fork()).ldelim();
        }
        if (m.levels != null && m.levels.length) {
            for (var i = 0; i < m.levels.length; ++i)
                $root.Metric.encode(m.levels[i], w.uint32(26).fork()).ldelim();
        }
        if (m.protocolVersion != null && Object.hasOwnProperty.call(m, "protocolVersion"))
            w.uint32(32).uint32(m.protocolVersion);
        if (m.bufferStartTimestampMillis != null && Object.hasOwnProperty.call(m, "bufferStartTimestampMillis"))
            w.uint32(40).uint64(m.bufferStartTimestampMillis);
        if (m.bufferEndTimestampMillis != null && Object.hasOwnProperty.call(m, "bufferEndTimestampMillis"))
            w.uint32(48).uint64(m.bufferEndTimestampMillis);
        if (m.appVersion != null && Object.hasOwnProperty.call(m, "appVersion"))
            $root.AppVersion.encode(m.appVersion, w.uint32(58).fork()).ldelim();
        if (m.clientOsType != null && Object.hasOwnProperty.call(m, "clientOsType"))
            w.uint32(64).int32(m.clientOsType);
        if (m.userId != null && Object.hasOwnProperty.call(m, "userId"))
            w.uint32(74).string(m.userId);
        return w;
    };
    MetricFrame.fromObject = function fromObject(d) {
        if (d instanceof $root.MetricFrame)
            return d;
        var m = new $root.MetricFrame();
        if (d.timers) {
            if (!Array.isArray(d.timers))
                throw TypeError(".MetricFrame.timers: array expected");
            m.timers = [];
            for (var i = 0; i < d.timers.length; ++i) {
                if (typeof d.timers[i] !== "object")
                    throw TypeError(".MetricFrame.timers: object expected");
                m.timers[i] = $root.Metric.fromObject(d.timers[i]);
            }
        }
        if (d.counters) {
            if (!Array.isArray(d.counters))
                throw TypeError(".MetricFrame.counters: array expected");
            m.counters = [];
            for (var i = 0; i < d.counters.length; ++i) {
                if (typeof d.counters[i] !== "object")
                    throw TypeError(".MetricFrame.counters: object expected");
                m.counters[i] = $root.Metric.fromObject(d.counters[i]);
            }
        }
        if (d.levels) {
            if (!Array.isArray(d.levels))
                throw TypeError(".MetricFrame.levels: array expected");
            m.levels = [];
            for (var i = 0; i < d.levels.length; ++i) {
                if (typeof d.levels[i] !== "object")
                    throw TypeError(".MetricFrame.levels: object expected");
                m.levels[i] = $root.Metric.fromObject(d.levels[i]);
            }
        }
        if (d.protocolVersion != null) {
            m.protocolVersion = d.protocolVersion >>> 0;
        }
        if (d.bufferStartTimestampMillis != null) {
            if ($util.Long)
                (m.bufferStartTimestampMillis = $util.Long.fromValue(d.bufferStartTimestampMillis)).unsigned = true;
            else if (typeof d.bufferStartTimestampMillis === "string")
                m.bufferStartTimestampMillis = parseInt(d.bufferStartTimestampMillis, 10);
            else if (typeof d.bufferStartTimestampMillis === "number")
                m.bufferStartTimestampMillis = d.bufferStartTimestampMillis;
            else if (typeof d.bufferStartTimestampMillis === "object")
                m.bufferStartTimestampMillis = new $util.LongBits(d.bufferStartTimestampMillis.low >>> 0, d.bufferStartTimestampMillis.high >>> 0).toNumber(true);
        }
        if (d.bufferEndTimestampMillis != null) {
            if ($util.Long)
                (m.bufferEndTimestampMillis = $util.Long.fromValue(d.bufferEndTimestampMillis)).unsigned = true;
            else if (typeof d.bufferEndTimestampMillis === "string")
                m.bufferEndTimestampMillis = parseInt(d.bufferEndTimestampMillis, 10);
            else if (typeof d.bufferEndTimestampMillis === "number")
                m.bufferEndTimestampMillis = d.bufferEndTimestampMillis;
            else if (typeof d.bufferEndTimestampMillis === "object")
                m.bufferEndTimestampMillis = new $util.LongBits(d.bufferEndTimestampMillis.low >>> 0, d.bufferEndTimestampMillis.high >>> 0).toNumber(true);
        }
        if (d.appVersion != null) {
            if (typeof d.appVersion !== "object")
                throw TypeError(".MetricFrame.appVersion: object expected");
            m.appVersion = $root.AppVersion.fromObject(d.appVersion);
        }
        switch (d.clientOsType) {
            case "UNKNOWN_OS_TYPE":
            case 0:
                m.clientOsType = 0;
                break;
            case "OS_IOS":
            case 1:
                m.clientOsType = 1;
                break;
            case "OS_ANDROID":
            case 2:
                m.clientOsType = 2;
                break;
            case "OS_WEB":
            case 3:
                m.clientOsType = 3;
                break;
        }
        if (d.userId != null) {
            m.userId = String(d.userId);
        }
        return m;
    };
    MetricFrame.toObject = function toObject(m, o) {
        if (!o)
            o = {};
        var d = {};
        if (o.arrays || o.defaults) {
            d.timers = [];
            d.counters = [];
            d.levels = [];
        }
        if (o.defaults) {
            d.protocolVersion = 0;
            if ($util.Long) {
                var n = new $util.Long(0, 0, true);
                d.bufferStartTimestampMillis = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
            }
            else
                d.bufferStartTimestampMillis = o.longs === String ? "0" : 0;
            if ($util.Long) {
                var n = new $util.Long(0, 0, true);
                d.bufferEndTimestampMillis = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
            }
            else
                d.bufferEndTimestampMillis = o.longs === String ? "0" : 0;
            d.appVersion = null;
            d.clientOsType = o.enums === String ? "UNKNOWN_OS_TYPE" : 0;
            d.userId = "";
        }
        if (m.timers && m.timers.length) {
            d.timers = [];
            for (var j = 0; j < m.timers.length; ++j) {
                d.timers[j] = $root.Metric.toObject(m.timers[j], o);
            }
        }
        if (m.counters && m.counters.length) {
            d.counters = [];
            for (var j = 0; j < m.counters.length; ++j) {
                d.counters[j] = $root.Metric.toObject(m.counters[j], o);
            }
        }
        if (m.levels && m.levels.length) {
            d.levels = [];
            for (var j = 0; j < m.levels.length; ++j) {
                d.levels[j] = $root.Metric.toObject(m.levels[j], o);
            }
        }
        if (m.protocolVersion != null && m.hasOwnProperty("protocolVersion")) {
            d.protocolVersion = m.protocolVersion;
        }
        if (m.bufferStartTimestampMillis != null && m.hasOwnProperty("bufferStartTimestampMillis")) {
            if (typeof m.bufferStartTimestampMillis === "number")
                d.bufferStartTimestampMillis = o.longs === String ? String(m.bufferStartTimestampMillis) : m.bufferStartTimestampMillis;
            else
                d.bufferStartTimestampMillis = o.longs === String ? $util.Long.prototype.toString.call(m.bufferStartTimestampMillis) : o.longs === Number ? new $util.LongBits(m.bufferStartTimestampMillis.low >>> 0, m.bufferStartTimestampMillis.high >>> 0).toNumber(true) : m.bufferStartTimestampMillis;
        }
        if (m.bufferEndTimestampMillis != null && m.hasOwnProperty("bufferEndTimestampMillis")) {
            if (typeof m.bufferEndTimestampMillis === "number")
                d.bufferEndTimestampMillis = o.longs === String ? String(m.bufferEndTimestampMillis) : m.bufferEndTimestampMillis;
            else
                d.bufferEndTimestampMillis = o.longs === String ? $util.Long.prototype.toString.call(m.bufferEndTimestampMillis) : o.longs === Number ? new $util.LongBits(m.bufferEndTimestampMillis.low >>> 0, m.bufferEndTimestampMillis.high >>> 0).toNumber(true) : m.bufferEndTimestampMillis;
        }
        if (m.appVersion != null && m.hasOwnProperty("appVersion")) {
            d.appVersion = $root.AppVersion.toObject(m.appVersion, o);
        }
        if (m.clientOsType != null && m.hasOwnProperty("clientOsType")) {
            d.clientOsType = o.enums === String ? $root.OsType[m.clientOsType] : m.clientOsType;
        }
        if (m.userId != null && m.hasOwnProperty("userId")) {
            d.userId = m.userId;
        }
        return d;
    };
    MetricFrame.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };
    return MetricFrame;
})();
module.exports = $root;
//# sourceMappingURL=metrics_web.js.map